import styled from 'styled-components';
import { hideScrollbar } from '@simplywallst/ui-core';

export const StyledNav = styled('nav')`
  position: sticky;
  background-color: ${({ theme }) => theme.color.charcoal};
  top: ${({ theme }) =>
    `calc(${theme.x8spacePx - 1}px + ${theme.safeAreaInsetTop})`};
  padding-top: ${({ theme }) => theme.x1}px;
  margin-bottom: ${({ theme }) => theme.x2}px;
  border-bottom: 1px solid ${({ theme }) => theme.color.spaceGray};
  z-index: 9000;
  width: 100%;
  overflow-y: hidden;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  ${hideScrollbar}
`;

export const StyledLink = styled('a')`
  text-decoration: none;
  color: inherit;
`;
